import logoCarousel from './carousel.js';
// Initialize carousels for .gd-network and .client-logos with 4s auto-transition
logoCarousel('.gd-network .carousel', 4000);
logoCarousel('.client-logos .carousel', 4000);
import lazyLoadImages, { lazyLoadHubspotForm } from './lazyLoadImages.js';
import { initSectionAnimations, handleHeroImageFadeIn } from './sectionAnimations.js';
import accordion from './accordion.js';


lazyLoadImages();
initSectionAnimations();
handleHeroImageFadeIn();

// Initialize accordion if .accordion exists on the page
if (document.querySelector('.accordion')) {
	// Check if it's an image accordion (has .image-stack or .image-panel sibling)
	const hasImageStack = document.querySelector('*:has(.accordion):has(.image-stack), *:has(.accordion):has(.image-panel)');
	accordion.init('.accordion', !!hasImageStack);
}

// Lazy load HubSpot form only if .hubspot-form exists
if (document.querySelector('.hubspot-form')) {
	lazyLoadHubspotForm();
}

// Enable smooth scrolling for anchor links
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('a[href^="#"]').forEach(link => {
		link.addEventListener('click', function(e) {
			const targetId = this.getAttribute('href').slice(1);
			const target = document.getElementById(targetId);
			if (target) {
				e.preventDefault();
				target.scrollIntoView({ behavior: 'smooth' });
			}
		});
	});
});


import fauxSelects from './fauxSelects.js';

import populateCountrySelect from './countrySelect.js';

if (document.getElementById('country')) {
	populateCountrySelect();
}

if (document.querySelector('select')) {
	fauxSelects();
}
